import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

// Components
import {
  // IconCompare,
  IconArrow,
} from 'wg-fe-ui';

// Types
import { useBreakpointValue } from '@wegroup/design-system';
import useSessionId from '../../../../../../../flows/src/hooks/useSessionId';
import { useLouiseSelector } from '../../../../../store/redux/store';
import { getTextForRiskObject } from '../../../../../services/productFactoryService';
import EmptyCardModalMobile from '../../../../../components/offers/offers-bottom-bar/EmptyCardModalMobile';
import BottomBar from '../../../../../components/offers/offers-bottom-bar/BottomBar';
import { mq } from '../../../../../../../common/src/utils/styledComponentsUtils';

interface Props {
  riskObject: string;
}

const OffersBottomBar: React.FC<React.PropsWithChildren<Props>> = ({
  riskObject,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const sessionId = useSessionId();
  const selectedOffers = useLouiseSelector(
    (state) => state.offers.selectedOffers,
  );
  const selectedRiskObjects = useLouiseSelector(
    (state) => state.selection.selectedRiskObjects,
  );
  const isSmallScreen = useBreakpointValue({ base: true, mobileM: false });
  const [showModal, setShowModal] = useState<boolean>(false);

  const sortedRiskObjects = [...selectedRiskObjects].sort();

  const nextRiskObject =
    sortedRiskObjects.sort()[
      sortedRiskObjects.findIndex((_riskObject) => _riskObject === riskObject) +
        1
    ];

  const getBottomBarContent = () => {
    if (nextRiskObject) {
      return getTextForRiskObject(nextRiskObject);
    }
    return t('Selected offers');
  };

  const getBottomBarIcon = () => {
    return isSmallScreen ? (
      <SmallIconArrow color="white" />
    ) : (
      <IconArrow color="white" />
    );
  };

  const getTotalSelectedOffers = () =>
    Object.values(selectedOffers).reduce((prev, curr) => prev + curr.length, 0);

  const getBottomBarAction = () => {
    if (nextRiskObject)
      return () =>
        history.push(
          `/sales-conversation/offers/overview/${nextRiskObject}?session_id=${sessionId}`,
        );

    return () =>
      getTotalSelectedOffers() > 0
        ? history.push(
            `/sales-conversation/offers/selected-offers?session_id=${sessionId}`,
          )
        : setShowModal(true);
  };

  return (
    <>
      <EmptyCardModalMobile
        onClose={() => setShowModal(false)}
        showModal={showModal}
      />
      <Wrapper
        inBasketAmount={getTotalSelectedOffers() || 0}
        onClick={getBottomBarAction()}
        onCircularButtonClick={() =>
          getTotalSelectedOffers() > 0
            ? history.push(
                `/sales-conversation/offers/selected-offers?session_id=${sessionId}`,
              )
            : setShowModal(true)
        }
        Icon={getBottomBarIcon()}
      >
        {getBottomBarContent()}
      </Wrapper>
    </>
  );
};

const SmallIconArrow = styled(IconArrow)`
  padding: 1rem;
`;

const Wrapper = styled(BottomBar)`
  margin-top: auto;
  ${mq.laptop} {
    display: none;
  }
`;

export default OffersBottomBar;
